import { Loader as BaseLoader, MantineColor, Stack, Text } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';

import s from './Loader.module.scss';

type LoaderProps = {
  className?: string;
  fullHeight?: boolean;
  text?: string | null;
  onTextClick?: () => void;
  textClassName?: string;
  type?: 'dots' | 'oval';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  gap?: 'sm' | 'md' | 'lg' | 'xl' | number;
  inline?: boolean;
  color?: MantineColor;
};

const Loader: React.FC<LoaderProps> = ({
  className,
  fullHeight,
  text,
  onTextClick,
  textClassName,
  type = 'oval',
  size = 'md',
  gap = 'sm',
  color,
  inline = false,
}) => {
  return (
    <div className={cn(className, s.root, fullHeight && s['root_full-height'])}>
      <Stack className={cn(inline && s.root__inline)} gap={gap} align="center">
        <BaseLoader color={color} type={type} size={size} />
        {text &&
          (onTextClick ? (
            <BaseClickable
              className={cn(s['root__text-clickable'], textClassName)}
              onClick={onTextClick}
              ariaLabel={text}
            >
              <Text size="md" className={cn(s.root__text, textClassName)}>
                {text}
              </Text>
            </BaseClickable>
          ) : (
            <Text size="md" className={cn(s.root__text, textClassName)}>
              {text}
            </Text>
          ))}
      </Stack>
    </div>
  );
};

export default React.memo(Loader);
